import { render, staticRenderFns } from "./Why.vue?vue&type=template&id=328f0632&scoped=true&"
import script from "./Why.vue?vue&type=script&lang=js&"
export * from "./Why.vue?vue&type=script&lang=js&"
import style0 from "./Why.vue?vue&type=style&index=0&id=328f0632&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "328f0632",
  null
  
)

export default component.exports